// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dhuoJ","delete":"styles_delete__3iSyJ","update":"styles_update__11k6Z","add":"styles_add__1jc7t"};